module.exports = __webpack_public_path__ + "static/media/menu-no-dnd-up.95b47c20.svg";